const NewProjectForm = ({ formSubmitHandler, buttonText }) => {
  return (
    <>
    <h1 id="new-project-title">New Project</h1>
    <hr className="mb-4" />
      <div className="my-2 w-50 container">
        <form onSubmit={formSubmitHandler} autoComplete="off">
          <label>Name</label>
          <input className="form-control mb-3" name="kitName" />
          <label>Kit Size</label>
          <select className="form-control mb-3" name="size">
            <option value="16">20'</option>
            <option value="20">25'</option>
            <option value="24">30'</option>
            <option value="27">35'</option>
            <option value="32">41'</option>
          </select>
          <label>Wall Height</label>
          <select name="h" className="form-control mb-3">
            <option value="96">8'</option>
            <option value="108">9'</option>
            <option value="120">10'</option>
            <option value="132">11'</option>
            <option value="144">12'</option>
            <option value="156">13'</option>
            <option value="168">14'</option>
          </select>

          <button type="submit">Create</button>
        </form>
      </div>
    </>
  );
};

export default NewProjectForm;
